import React, {useEffect, useState} from "react";
import './GenericProfileSegmentComponent.css'
import {ProfileEducationSegment} from "./ProfileEducationSegment";
import {ProfileExperienceSegment} from "./ProfileExperienceSegment";
import {ProfileAdditionalQualificationSegment} from "./ProfileAdditionalQualificationSegment";
import {ProfileAdditionalInformationSegment} from "./ProfileAdditionalInformationSegment";
import {ProfileLanguageSegment} from "./ProfileLanguageSegment";
import {ProfileScientificPaperSegment} from "./ProfileScientificPaperSegment";
import {ProfileFieldOfInterestSegment} from "./ProfileFieldOfInterestSegment";
import {ProfileSkillSegment} from "./ProfileSkillSegment";
import {ProfileItSkillSegment} from "./ProfileItSkillSegment";
import {ProfileDocumentSegment} from "./ProfileDocumentSegment";
import {ProfilePersonalInformationSegment} from "./ProfilePersonalnformationSegment";
import {ProfileDrivingLicenseSegment} from "./ProfileDrivingLicenseSegment";

export const GenericProfileSegmentComponent = ({isPreview, candidate, setCandidate, title, iconImage, type, updateCandidate, setUpdateCandidate}) => {

    const [segment, setSegment] = useState();

    useEffect(()=> {
        if(type === 'PERSONAL_INFORMATION') {
            setSegment(<ProfilePersonalInformationSegment
                candidate={candidate}
                isPreview={isPreview}
                setCandidate={setCandidate}
                updateCandidate={updateCandidate}
                setUpdateCandidate={setUpdateCandidate}/>)
        } else if(type==='EDUCATION'){
            setSegment(<ProfileEducationSegment
                candidate={candidate}
                isPreview = {isPreview}/>)
        } else if(type === 'FIELD_OF_INTEREST'){
            setSegment(<ProfileFieldOfInterestSegment
                candidate={candidate}
                isPreview={isPreview}/>)
        } else if(type === 'EXPERIENCE'){
            setSegment(<ProfileExperienceSegment
                candidate={candidate}
                isPreview={isPreview}/>)
        } else if(type === 'LANGUAGE'){
            setSegment(<ProfileLanguageSegment
                candidate={candidate}
                isPreview={isPreview}/>)
        } else if(type === 'SCIENTIFIC_PAPER'){
            setSegment(<ProfileScientificPaperSegment
                candidate={candidate}
                isPreview={isPreview}/>)
        } else if(type === 'SKILL'){
            setSegment(<ProfileSkillSegment
                candidate={candidate}
                isPreview={isPreview}/>)
        } else if(type === 'IT_SKILL'){
            setSegment(<ProfileItSkillSegment
                candidate={candidate}
                isPreview={isPreview}/>)
        } else if(type === 'DRIVING_LICENSE'){
            setSegment(<ProfileDrivingLicenseSegment
                candidate={candidate}
                isPreview={isPreview}/>)
        } else if(type === 'ADDITIONAL_QUALIFICATION'){
            setSegment(<ProfileAdditionalQualificationSegment
                candidate={candidate}
                isPreview={isPreview}/>)
        } else if(type === 'DOCUMENT'){
            setSegment(<ProfileDocumentSegment
                candidate={candidate}
                isPreview={isPreview}
                setCandidate={setCandidate}
                updateCandidate={updateCandidate}
                setUpdateCandidate={setUpdateCandidate}/>)
        } else if(type === 'ADDITIONAL_INFORMATION'){
            setSegment(<ProfileAdditionalInformationSegment
                candidate={candidate}
                isPreview={isPreview}
                setCandidate={setCandidate}
                updateCandidate={updateCandidate}
                setUpdateCandidate={setUpdateCandidate}/>)
        }
    }, [])
    return (
        <div className='segment_main_container'>
            <div>
               <div className='circle_image_div'>
                   {iconImage &&  <img src={iconImage}/>}
                   <h4 className='segment_title'>{title}</h4>
               </div>
                <div className='profile_segment_blueLine'></div>
            </div>
                {segment}
        </div>
    )
}